<template>
  <div class="tw-mt-6 tw-w-full tw-rounded-lg tw-border tw-bg-white tw-p-6 tw-shadow-md md:tw-mt-0">
    <h2
class="tw-text-xl tw-font-semibold"
style="margin-bottom: 10px"
>
      Customer Checkout
    </h2>

    <form
      ref="checkoutForm"
      @submit.prevent="onSubmit"
    >
      <input
        type="hidden"
        name="payment-method"
        :value="paymentMethod"
      >
      <input
        type="hidden"
        name="paymentMethod"
        :value="paymentMethod"
      >
      <input
        type="hidden"
        name="quote_id"
        :value="quoteId"
      >

      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
        <input
          v-model="formData.first_name"
          type="text"
          name="first_name"
          placeholder="First name"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
        <input
          v-model="formData.last_name"
          type="text"
          name="last_name"
          placeholder="Last name"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
        <input
          v-model="formData.company"
          type="text"
          name="company"
          placeholder="Company (optional)"
          class="tw-w-full tw-border tw-p-2 tw-rounded md:tw-col-span-2"
        >
        <input
          v-model="formData.phone"
          type="tel"
          name="phone"
          placeholder="Phone"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
        <input
          v-model="formData.email"
          type="email"
          name="email"
          placeholder="Email"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
      </div>

      <!-- Order reference & PO number -->
      <h3 class="tw-text-lg tw-font-medium tw-mt-4">
        Order Details
      </h3>
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
        <input
          v-model="formData.customer_reference"
          type="text"
          name="customer_reference"
          placeholder="Your reference (optional)"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
        >
        <input
          v-model="formData.po_number"
          type="text"
          name="po_number"
          placeholder="PO number (optional)"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
        >
      </div>

      <!-- Billing & Shipping -->
      <h3 class="tw-text-lg tw-font-medium tw-mt-4">
        Billing Info
      </h3>
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
        <input
          v-model="formData.billing_address_one"
          type="text"
          name="billing_address_one"
          placeholder="Address Line 1"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
        <input
          v-model="formData.billing_address_two"
          type="text"
          name="billing_address_two"
          placeholder="Address Line 2"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
        >
        <input
          v-model="formData.billing_address_city"
          type="text"
          name="billing_city"
          placeholder="City"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
        <input
          v-model="formData.billing_address_postcode"
          type="text"
          name="billing_postcode"
          placeholder="Postal code"
          class="tw-w-full tw-border tw-p-2 tw-rounded"
          required
        >
      </div>
      <label
        class="tw-flex tw-items-center tw-mt-3"
      >
        <input
          v-model="shippingSameAsBilling"
          type="checkbox"
          class="tw-mr-2"
          name="shipping_is_different"
          @change="updateBillingAddress"
        >
        <span class="tw-text-sm tw-text-slate-700">
          Tick if delivery address is the same as billing address
        </span>
      </label>

      <div
        v-if="!shippingSameAsBilling"
        class="tw-mt-3"
      >
        <h3 class="tw-text-base tw-font-medium tw-mb-2">
          Delivery Info
        </h3>
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
          <input
            v-model="formData.shipping_contact_name"
            type="text"
            name="shipping_contact_name"
            placeholder="Delivery contact name"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
            required
          >
          <input
            v-model="formData.shipping_contact_email"
            type="email"
            name="shipping_contact_email"
            placeholder="Delivery email address"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
            required
          >
          <input
            v-model="formData.shipping_contact_phone"
            type="tel"
            name="shipping_contact_phone"
            placeholder="Delivery mobile number"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
            required
          >
          <input
            v-model="formData.shipping_address_one"
            type="text"
            name="shipping_address_one"
            placeholder="Address Line 1"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
            required
          >
          <input
            v-model="formData.shipping_address_two"
            type="text"
            name="shipping_address_two"
            placeholder="Address Line 2"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
          >
          <input
            v-model="formData.shipping_address_city"
            type="text"
            name="shipping_city"
            placeholder="City"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
            required
          >
          <input
            v-model="formData.shipping_address_postcode"
            type="text"
            name="shipping_postcode"
            placeholder="Postal code"
            class="tw-w-full tw-border tw-p-2 tw-rounded"
            required
          >
        </div>
      </div>


      <!-- Terms and Conditions -->
      <!-- BACS / Bank Transfer Details -->
      <div
        v-if="paymentType === 'bacs' && !isZeroTotal"
        class="tw-mt-6 tw-rounded-lg tw-border tw-border-blue-200 tw-bg-blue-50 tw-p-4"
      >
        <h3 class="tw-text-sm tw-font-bold tw-text-blue-900 tw-mb-2">
          BACS or Direct Bank Transfer
        </h3>
        <p class="tw-text-xs tw-text-blue-800 tw-mb-3">
          Please transfer the balance to our bank account using your Job Number as the reference.
        </p>
        <div class="tw-space-y-1.5 tw-text-sm tw-text-slate-800">
          <div><strong>Bank:</strong> Allica Bank</div>
          <div><strong>Sort Code:</strong> 04-13-76</div>
          <div><strong>Account Number:</strong> 00398980</div>
          <div><strong>Reference:</strong> {{ quoteData?.quote?.job_number || 'Job Number' }}</div>
          <div v-if="isFiftyFifty"><strong>Amount to Transfer (50% Deposit):</strong> £{{ cappedTotal.toLocaleString('en-GB', { minimumFractionDigits: 2 }) }}</div>
          <div v-else><strong>Amount to Transfer:</strong> £{{ cappedTotal.toLocaleString('en-GB', { minimumFractionDigits: 2 }) }}</div>
        </div>
      </div>

      <!-- Super Payments Embedded Checkout -->
      <div
        v-if="paymentType === 'super' && !isZeroTotal"
        class="tw-mt-6"
      >
        <h3 class="tw-text-lg tw-font-medium tw-mb-3">
          Payment
        </h3>
        <div
          v-if="superLoading"
          class="tw-text-center tw-py-4"
        >
          <span class="tw-text-gray-500">Loading payment form...</span>
        </div>
        <super-checkout
          v-if="superSessionToken"
          :amount="cartAmount"
          :checkout-session-token="superSessionToken"
          :theme="superTheme"
        />
      </div>

      <!-- Deposit notice when 50/50 payment is required or total exceeds payment limit -->
      <div
        v-if="isFiftyFifty || exceedsPaymentLimit"
        class="tw-mt-4 tw-rounded tw-border tw-border-amber-300 tw-bg-amber-50 tw-p-4 tw-text-sm tw-text-amber-800"
      >
        <p class="tw-font-semibold tw-mb-1">
          {{ isFiftyFifty ? '50% Upfront Payment Required' : 'Deposit Payment' }}
        </p>
        <p v-if="isFiftyFifty">
          Your payment method requires a 50% deposit upfront.
          This payment of <strong>£{{ cappedTotal.toLocaleString('en-GB', { minimumFractionDigits: 2 }) }}</strong>
          is 50% of your total balance.
          The remaining 50% will be added to your credit account.
        </p>
        <p v-else>
          Your quote total exceeds the maximum online payment amount.
          This payment of <strong>£{{ cappedTotal.toLocaleString('en-GB', { minimumFractionDigits: 2 }) }}</strong>
          is a deposit — not the full balance.
          A member of the Quickslide team will be in contact to collect the remaining balance.
        </p>
      </div>

      <button
        class="tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-mt-4 tw-w-full disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
        type="submit"
        :disabled="submitting || !deliveryAccepted || !kerbsideAccepted || !vehicleSizeAccepted || (paymentType === 'super' && !isZeroTotal && !superSessionToken)"
      >
        <span v-if="submitting">{{ isZeroTotal ? 'Processing sign-off…' : 'Processing payment…' }}</span>
        <span v-else-if="!deliveryAccepted || !kerbsideAccepted || !vehicleSizeAccepted">Accept delivery instructions to continue</span>
        <span v-else>{{ submitLabel }}</span>
      </button>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, inject, computed, nextTick } from 'vue'

export default {
  name: 'CheckoutForm',
  props: {
    quoteData: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      default: '2'
    },
    paymentType: {
      type: String,
      default: 'super',
      validator: (v) => ['super', 'account', 'bacs'].includes(v)
    },
    // Approver details passed from Step 1
    approvedToSign: {
      type: Boolean,
      default: false
    },
    approverName: {
      type: String,
      default: ''
    },
    approverEmail: {
      type: String,
      default: ''
    },
    preferredDeliveryWeek: {
      type: String,
      default: ''
    },
    deliveryAccepted: {
      type: Boolean,
      default: false
    },
    kerbsideAccepted: {
      type: Boolean,
      default: false
    },
    vehicleSizeAccepted: {
      type: Boolean,
      default: false
    },
    notes: {
      type: String,
      default: ''
    }
  },
  emits: ['account-success', 'account-error', 'super-success', 'super-error'],
  setup(props, { emit }) {
    const quoteBuilderService = inject('quoteBuilderService')

    const checkoutForm = ref(null)
    const shippingSameAsBilling = ref(false)
    const quoteId = ref('')
    const submitting = ref(false)

    // Super Payments state
    const superSessionToken = ref('')
    const superSessionId = ref('')
    const superLoading = ref(false)
    const superError = ref('')
    const superScriptLoaded = ref(false)

    const submitLabel = computed(() => {
      if (isZeroTotal.value) return 'COMPLETE SIGNOFF'
      if (props.paymentType === 'account') return 'ADD TO ACCOUNT'
      if (props.paymentType === 'bacs') return 'SUBMIT SIGNOFF'
      if (props.paymentType === 'super') {
        return isFiftyFifty.value ? 'PAY 50% DEPOSIT NOW' : 'PAY NOW'
      }
      return 'SUBMIT'
    })

    // Payment limit from env (pounds) – defaults to 12000
    const paymentLimit = parseFloat(process.env.VUE_APP_QUOTE_PAYMENT_LIMIT) || 12000

    // Original quote total in pounds (with voucher discount applied)
    const quoteTotal = computed(() => {
      const baseTotal = parseFloat(props.quoteData?.quote?.total || props.quoteData?.total || 0)
      const discount = parseFloat(props.quoteData?.quote?.voucher_discount || 0)
      return Math.max(0, baseTotal - discount)
    })

    const isZeroTotal = computed(() => quoteTotal.value === 0)

    const isFiftyFifty = computed(() => {
      const pmId = props.quoteData?.quote?.payment_method_id
      return pmId === 4 || pmId === 5 || pmId === '4' || pmId === '5'
    })

    // Whether the total exceeds the payment limit
    const exceedsPaymentLimit = computed(() => {
      if (isFiftyFifty.value) return false
      return quoteTotal.value > paymentLimit
    })

    // Capped total for the transaction (pounds)
    const cappedTotal = computed(() => {
      if (isFiftyFifty.value) {
        return quoteTotal.value * 0.5
      }
      return exceedsPaymentLimit.value ? paymentLimit : quoteTotal.value
    })

    // Cart amount in pence for Super Payments (capped)
    const cartAmount = computed(() => {
      // Super Payments expects amount in pence
      return Math.round(cappedTotal.value * 100)
    })

    // Theme configuration for Super Payments (optional customisation)
    const superTheme = computed(() => {
      return JSON.stringify({
        hideSuperApp: false,
        container: {
          backgroundColor: '#ffffff',
          borderRadius: '8px',
        },
      })
    })

    // Load Super Payments script dynamically
    const loadSuperPaymentsScript = () => {
      return new Promise((resolve, reject) => {
        if (superScriptLoaded.value || window.superCheckout) {
          superScriptLoaded.value = true
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = 'https://cdn.superpayments.com/js/payment.js'
        script.async = true
        script.onload = () => {
          superScriptLoaded.value = true
          resolve()
        }
        script.onerror = () => reject(new Error('Failed to load Super Payments script'))
        document.head.appendChild(script)
      })
    }

    // Fetch Super Payments checkout session
    const initSuperPayments = async () => {
      if (props.paymentType !== 'super' || isZeroTotal.value) return

      superLoading.value = true
      superError.value = ''

      try {
        await loadSuperPaymentsScript()

        const token = props.quoteData?.quote?.token
        if (!token) {
          throw new Error('Quote token not available')
        }

        const response = await quoteBuilderService.getSuperCheckoutSession(token)
        superSessionToken.value = response.data.checkoutSessionToken
        superSessionId.value = response.data.checkoutSessionId
      } catch (err) {
        console.error('Failed to initialise Super Payments:', err)
        superError.value = err?.response?.data?.message || err?.message || 'Failed to load payment form'
      } finally {
        superLoading.value = false
      }
    }

    const formData = ref({
      first_name: '',
      last_name: '',
      company: '',
      phone: '',
      email: '',

      // Order metadata
      customer_reference: '',
      po_number: '',

      // Addresses
      shipping_contact_name: '',
      shipping_contact_email: '',
      shipping_contact_phone: '',
      shipping_address_one: '',
      shipping_address_two: '',
      shipping_address_city: '',
      shipping_address_postcode: '',

      billing_address_one: '',
      billing_address_two: '',
      billing_address_city: '',
      billing_address_postcode: '',
      marketing_accepted: false,
    })

    // Pre-fill form with quote customer data if available
    onMounted(async () => {
      if (props.quoteData) {
        // Set quote ID
        quoteId.value = props.quoteData.quote?.id || ''
        
        // Pre-fill customer details from quote object
        if (props.quoteData.quote) {
          const q = props.quoteData.quote

          // Pre-fill company name from quote (customer_name typically holds company)
          formData.value.company = q.customer_name || q.name || ''
          // Don't pre-fill first/last name - let user enter their personal details
          formData.value.email = q.customer_email || q.email || ''
          formData.value.phone = q.customer_phone || q.phone || ''
          quoteId.value = q.id || ''
        }
        
        // Pre-fill billing address:
        // 1) Prefer new quote.billing_address object from API
        // 2) Fall back to any legacy props.quoteData.billing / props.quoteData.shipping structure
        const billing = props.quoteData.quote?.billing_address
          || props.quoteData.billing
          || props.quoteData.shipping

        if (billing) {
          formData.value.billing_address_one = billing.address_line_one || ''
          formData.value.billing_address_two = billing.address_line_two || ''
          formData.value.billing_address_city = billing.address_city || ''
          formData.value.billing_address_postcode = billing.address_postcode || ''
        }
      }

      // Initialise Super Payments if needed
      await initSuperPayments()
    })

    const getPostUrl = () => {
      return process.env.VUE_APP_API_URL + '/quote/checkout/' + props.quoteData.quote.token  + '/submit'
    }

    const buildAccountPayload = (pending = false, account = false) => {
      return {
        quote_id: quoteId.value,
        paymentMethod: props.paymentMethod,
        payment_method: props.paymentMethod,
        pending,
        account,

        first_name: formData.value.first_name,
        last_name: formData.value.last_name,
        company: formData.value.company,
        phone: formData.value.phone,
        email: formData.value.email,

        // Order metadata
        customer_reference: formData.value.customer_reference,
        po_number: formData.value.po_number,
        approved_to_sign: props.approvedToSign ? 1 : 0,
        approver_name: props.approverName,
        approver_email: props.approverEmail,

        // Addresses
        shipping_contact_name: shippingSameAsBilling.value ? formData.value.first_name + ' ' + formData.value.last_name : formData.value.shipping_contact_name,
        shipping_contact_email: shippingSameAsBilling.value ? formData.value.email : formData.value.shipping_contact_email,
        shipping_contact_phone: shippingSameAsBilling.value ? formData.value.phone : formData.value.shipping_contact_phone,
        shipping_address_one: shippingSameAsBilling.value ? formData.value.billing_address_one : formData.value.shipping_address_one,
        shipping_address_two: shippingSameAsBilling.value ? formData.value.billing_address_two : formData.value.shipping_address_two,
        shipping_city: shippingSameAsBilling.value ? formData.value.billing_address_city : formData.value.shipping_address_city,
        shipping_postcode: shippingSameAsBilling.value ? formData.value.billing_address_postcode : formData.value.shipping_address_postcode,

        billing_address_one: formData.value.billing_address_one,
        billing_address_two: formData.value.billing_address_two,
        billing_city: formData.value.billing_address_city,
        billing_postcode: formData.value.billing_address_postcode,

        acceptTerms: true, // Terms accepted in Step 1

        preferred_delivery_week: props.preferredDeliveryWeek,

        // Mirror the form input name; backend may expect boolean-ish values
        billing_is_shipping: shippingSameAsBilling.value ? 1 : 0,

        notes: props.notes,
      }
    }

    const onSubmit = async (event) => {
      if (!quoteBuilderService) {
        emit('account-error', 'quoteBuilderService not available')
        return
      }

      submitting.value = true

      try {
        const token = props.quoteData?.quote?.token

        if (props.paymentType === 'account' || props.paymentType === 'bacs' || isZeroTotal.value) {
          // Account / BACS payment flow (or zero-total signoff acting like account)
          const response = await quoteBuilderService.submitQuoteToAccount(token, buildAccountPayload())
          emit('account-success', response?.data)
        } else if (props.paymentType === 'super') {
          // Super Payments embedded flow
          await handleSuperPayment(token)
        }
      } catch (err) {
        const errorMsg = err?.response?.data?.message || err?.message || 'Payment failed'
        if (props.paymentType === 'account' || props.paymentType === 'bacs') {
          emit('account-error', errorMsg)
        } else {
          emit('super-error', errorMsg)
        }
      } finally {
        submitting.value = false
      }
    }

    const handleSuperPayment = async (token) => {
      if (!window.superCheckout) {
        throw new Error('Super Payments not loaded')
      }
      console.log('[SP Debug] Calling submit() at:', new Date().toISOString())
      const result = await window.superCheckout.submit()
      console.log('[SP Debug] submit() resolved:', result.status, 'at:', new Date().toISOString())

      if (result.status === 'FAILURE') {
        const errorMessage = result.errorMessage || 
          'Something went wrong. No money has been taken from your account. Please refresh the page and try again.'
        throw new Error(errorMessage)
      }

      if (result.status !== 'SUCCESS') {
        throw new Error('Payment was not completed')
      }

      // Save quote details to our server prioer to payment
      const submitDataResponse = await quoteBuilderService.submitQuoteToAccount(token, buildAccountPayload(true))

      // Super Proceed Endpoint processed by the erver
      console.log('[SP Debug] Calling proceed at:', new Date().toISOString())
      const payload = buildSuperProceedPayload()
      const response = await quoteBuilderService.proceedSuperPayment(token, payload)

      // Step 3: Redirect to the URL provided by Super Payments
      if (response.data?.redirectUrl) {
        window.location.href = response.data.redirectUrl
      } else {
        emit('super-success', response?.data)
      }
    }

    const buildSuperProceedPayload = () => {
      const baseUrl = window.location.origin
      const token = props.quoteData?.quote?.token
      const apiUrl = process.env.VUE_APP_API_URL

      return {
        amount: cartAmount.value,
        email: formData.value.email,
        phone: formData.value.phone,
        externalReference: quoteId.value,
        checkoutSessionId: superSessionId.value,
        successUrl: `${apiUrl}/super/confirm/${token}`,
        failureUrl: `${baseUrl}/?token=${token}&type=failure`,
        cancelUrl: `${baseUrl}/?token=${token}&type=cancel`,

        // Include customer and address details
        first_name: formData.value.first_name,
        last_name: formData.value.last_name,
        company: formData.value.company,

        // Order metadata
        customer_reference: formData.value.customer_reference,
        po_number: formData.value.po_number,
        approved_to_sign: props.approvedToSign ? 1 : 0,
        approver_name: props.approverName,
        approver_email: props.approverEmail,

        // Addresses
        shipping_contact_name: shippingSameAsBilling.value ? formData.value.first_name + ' ' + formData.value.last_name : formData.value.shipping_contact_name,
        shipping_contact_email: shippingSameAsBilling.value ? formData.value.email : formData.value.shipping_contact_email,
        shipping_contact_phone: shippingSameAsBilling.value ? formData.value.phone : formData.value.shipping_contact_phone,
        shipping_address_one: shippingSameAsBilling.value ? formData.value.billing_address_one : formData.value.shipping_address_one,
        shipping_address_two: shippingSameAsBilling.value ? formData.value.billing_address_two : formData.value.shipping_address_two,
        shipping_city: shippingSameAsBilling.value ? formData.value.billing_address_city : formData.value.shipping_address_city,
        shipping_postcode: shippingSameAsBilling.value ? formData.value.billing_address_postcode : formData.value.shipping_address_postcode,
        billing_address_one: formData.value.billing_address_one,
        billing_address_two: formData.value.billing_address_two,
        billing_city: formData.value.billing_address_city,
        billing_postcode: formData.value.billing_address_postcode,
        billing_is_shipping: shippingSameAsBilling.value ? 1 : 0,
        preferred_delivery_week: props.preferredDeliveryWeek,
        notes: props.notes,
      }
    }

    const updateBillingAddress = () => {
      // When shipping address is toggled to be the same, clear shipping fields
      // so user can enter a fresh delivery address if toggled back
      if (shippingSameAsBilling.value) {
        formData.value.shipping_contact_name = ''
        formData.value.shipping_contact_email = ''
        formData.value.shipping_contact_phone = ''
        formData.value.shipping_address_one = ''
        formData.value.shipping_address_two = ''
        formData.value.shipping_address_city = ''
        formData.value.shipping_address_postcode = ''
      }
    }

    return {
      checkoutForm,
      shippingSameAsBilling,
      formData,
      quoteId,
      updateBillingAddress,
      onSubmit,
      submitting,
      submitLabel,
      // Super Payments
      superSessionToken,
      superLoading,
      superError,
      superTheme,
      cartAmount,
      isZeroTotal,
      isFiftyFifty,
      // Deposit cap
      exceedsPaymentLimit,
      cappedTotal,
    }
  }
}
</script>

<style scoped>
/* Custom styles if needed */
</style>
